import { callFunction } from "./functions-client";

// AI writing-assist surface (LOS Phase 16). Server-side only; the gateway degrades to
// 501 when unconfigured, which the UI surfaces gracefully.
export type AssistKind = "job_description" | "load_description" | "outreach";

export const aiStatus = () =>
  callFunction<{ configured: boolean }>("ai/status", { method: "GET" });

export const aiAssist = (kind: AssistKind, input: string) =>
  callFunction<{ text: string }>("ai/assist", { body: { kind, input } });
